import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { ToDateTimeText, ToDateFullMonthText } from "../../utils/date";
//Material
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
//Component
import { Modal } from "../../stories/modal";
import FormInput from "../../stories/hook-controls/input";
import { ReactTable } from "../../stories/react-table";
import * as alertDialog from "../../utils/alert";
//Function

import { setDataToFormHookV2, isEmptyStr } from "../../utils/common-function";
import { formatDateTime } from "../../utils/common-function"
import { TextField, Divider } from "@material-ui/core";
import * as api from "./api";
import * as common from "../../utils/common-function";
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import { API_URL } from "../../utils/api-utils";
import BootstrapTable from 'react-bootstrap-table-next';

const useStyles = makeStyles((theme) => ({

    textLabel: {
        color: '#000',
        marginTop: '-10px'
    },
    formControl: {
        minWidth: 150,
    },
    labelInput:{
        minWidth: 150,
        
    },
    textFieldUser:{
        color: '#e0e0e0 !important'
    }
}));


function ModalAddEdit(props) {
    const classes = useStyles();
    const { open } = props;
    const { userID,APP_ID, ...otherprops } = props;

    const method = useForm();
    const { register, getValues } = method;
    const { setValue, setError, clearErrors, errors, control } = method;
    const [DataInfo, setDataInfo] = useState([]);
    const [initModal, setInitModal] = useState([]);
    const [application, setApplication] = useState(0);
    const [spiAuthorize, setSpiAuthorize] = useState(0);
    const spiConst = "spi-id-";

    useEffect(() => {
        if (!open) return;
        initScreen(userID,APP_ID);
    }, [userID,APP_ID, setValue, open]);

    const initScreen = async (userID,pAPP_ID) => {
        let param = { USER_ID: userID,APPLICATION_ID : pAPP_ID };
        let res = await api.InitScreen(param);
        setInitModal([]);
        setInitModal(res);
        setApplication(res?.Info?.APPLICATION_ID);
        setSpiAuthorize(spiConst+res?.Info?.SPI_GROUP_ID);
    }

    const handleChangeApplication = (event) => {
        setApplication(event.target.value);
    };

    const handleChangeSPI = (event) => {
        console.log(event.target.value);
        setSpiAuthorize(event.target.value);
    };


    const saveAuthorize = async () => {
        let newSPI = spiAuthorize.split(spiConst);
       // console.log(newSPI[1]);
        let param = { ID: initModal?.Info?.ID ,USER_ID: getValues().USER_ID, APPLICATION_ID:application, SPI_GROUP_ID: parseInt(newSPI[1]),PERMISSION : getValues().PERMISSION ,REMARK : getValues().REMARK};
        if (getValues().USER_ID === '') {
            alertDialog.ErrorDialog("Please Input User ID.");
            return;
        }
        if(application === 0){
            alertDialog.ErrorDialog("Please select application.");
            return;
        }
        // if (typeof userID === "undefined") {
        //     let res = await api.CheckDuplicateQuata(param);
        //     if (res.ResultCode === 20) {
        //         alertDialog.ErrorDialog(res?.Message);
        //         return;
        //     }
        // }
         let resSave = await api.SaveSPIAuthorize(param);
        if (resSave.ResultCode === 10) { //Success
            alertDialog.SuccessShowButtonCloseModal("Add/Edit Completed.", props);
            return;
        }

        if (resSave.ResultCode === 20) {
            alertDialog.ErrorDialog(resSave?.Message);
            return;
        }



    }
    return (
        <Modal {...otherprops} SaveText="Save" onSave={saveAuthorize} maxWidth="md" title={typeof userID !== "undefined" ? "Edit Authorize" : "Add Authorize"}>

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Grid container spacing={1}>
                        <Grid item xs={2}>
                            <FormControl variant="outlined" className={classes.labelInput}>
                                <InputLabel className={classes.textLabel}>User ID : </InputLabel>
                            </FormControl>
                        </Grid>
                        <Grid item xs={4} className={classes.textFieldUser}>
                            <TextField
                                id="outlined-full-width"
                                label=""
                                name="USER_ID"
                                inputRef={register}
                                style={{ margin: 2 }}
                                fullWidth
                                margin="normal"
                                // InputProps={{
                                //     readOnly: true,
                                //   }}
                              
                               variant="outlined"
                               defaultValue={userID}
                               disabled={typeof userID === "undefined" ? false : true}
                            // onChange={onInputJobChange}
                            // onBlurCapture={onCheckDulplicate}

                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} hidden={typeof userID === "undefined" ? false : true} >
                        <Grid item xs={2}>
                            <FormControl variant="outlined" className={classes.labelInput}>
                                <InputLabel className={classes.textLabel}>Application : </InputLabel>
                            </FormControl>
                        </Grid>
                        <Grid item xs={8}>
                            <FormControl variant="outlined" className={classes.formControl}>
                                <Select
                                    labelId="simple-select-outlined-label"
                                    id="simple-select-outlined"
                                    name="APPLICATION"
                                    value={application}
                                    onChange={handleChangeApplication}

                                >
                                    {initModal?.List_Applications?.map((item) => (
                                        <MenuItem key={item?.APP_ID} value={item.APP_ID}>{item?.APP_NAME}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={2}>
                            <FormControl variant="outlined" className={classes.labelInput}>
                                <InputLabel className={classes.textLabel}>SPI Purpose : </InputLabel>
                            </FormControl>
                        </Grid>
                        <Grid item xs={9} className={classes.textXS12}>
                            <RadioGroup row aria-label="SpiType" name="SPI_TYPE" value={spiAuthorize}  onChange={handleChangeSPI}
                            >
                                {initModal?.List_SPI_GROUP?.map((item, index) => (
                                    <FormControlLabel value={spiConst+item.SPI_GROUP_ID} control={<Radio  />} label={item.SPI_GROUP_NAME} />

                                ))}
                            </RadioGroup>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={2}>
                            <FormControl variant="outlined" className={classes.labelInput}>
                                <InputLabel className={classes.textLabel}>Permission : </InputLabel>
                            </FormControl>
                        </Grid>
                        <Grid item xs={9}>
                            {initModal?.List_EncryptType?.map((item, index) => (
                                <FormControl key={index} variant="outlined" className={classes.checkWeekly} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                //  onChange={handleChangeWeekly}
                                                name="PERMISSION"
                                                color="primary"
                                                value={item.ENCRYPT_ID}
                                                inputRef={register}
                                                defaultChecked={initModal?.Info?.PERMISSION?.includes(item.ENCRYPT_ID)}
                                            />
                                        }
                                        label={item.ENCRYPT_NAME}
                                    />
                                </FormControl>
                            ))}
                        </Grid>

                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item xs={2}>
                            <FormControl variant="outlined" className={classes.labelInput}>
                                <InputLabel className={classes.textLabel}> Remark : </InputLabel>
                            </FormControl>
                        </Grid>
                        <Grid item xs={9}>
                            <TextField
                                id="outlined-full-width"
                                label=""
                                style={{ margin: 8 }}
                                multiline
                                rows={10}
                                fullWidth
                                inputRef={register}
                                name="REMARK"
                                margin="normal"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                variant="outlined"
                               defaultValue={initModal?.Info?.REMARK}
                            // hidden={hiddenInputMail}
                            />
                        </Grid>
                    </Grid>
                </Grid>

            </Grid>
        </Modal>
    );
}
export default ModalAddEdit;
